import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  Box, Button, TextField, Typography, Paper, Container, Alert, CircularProgress
} from '@mui/material';
import { styled } from '@mui/material/styles';
import axios from 'axios';
import logoPainel from '../imagens/logopainelftm.png.ico';

const PageContainer = styled(Container)(({ theme }) => ({
  minHeight: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: theme.palette.background.default,
}));

const StyledPaper = styled(Paper)(({ theme }) => ({
  background: 'rgba(17, 24, 39, 0.7)',
  backdropFilter: 'blur(10px)',
  padding: theme.spacing(4),
  borderRadius: '16px',
  border: '1px solid rgba(124, 58, 237, 0.2)',
  maxWidth: '400px',
  width: '100%',
  margin: 'auto',
}));

export default function ResetPassword() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ novaSenha: '', confirmSenha: '' });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (formData.novaSenha !== formData.confirmSenha) {
      setError('As senhas não coincidem');
      return;
    }
    if (formData.novaSenha.length < 6) {
      setError('A senha deve ter no mínimo 6 caracteres');
      return;
    }

    setLoading(true);
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/auth/reset-password`,
        { token, novaSenha: formData.novaSenha },
        { timeout: 15000 }
      );
      if (res.data.success) {
        setSuccess(true);
      } else {
        setError(res.data.message || 'Erro ao redefinir senha.');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Link inválido ou expirado.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <PageContainer>
      <StyledPaper elevation={3}>
        <Box sx={{ textAlign: 'center', mb: 3 }}>
          <img src={logoPainel} alt="Painel FTM" style={{ width: 64, height: 64, borderRadius: 12 }} />
        </Box>
        <Typography variant="h5" sx={{ color: '#fff', textAlign: 'center', mb: 1 }}>
          Nova Senha
        </Typography>
        <Typography sx={{ color: '#9CA3AF', textAlign: 'center', mb: 3, fontSize: '0.9rem' }}>
          Digite sua nova senha abaixo.
        </Typography>

        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

        {success ? (
          <Box sx={{ textAlign: 'center' }}>
            <Alert severity="success" sx={{ mb: 3 }}>
              Senha redefinida com sucesso!
            </Alert>
            <Button
              variant="contained" onClick={() => navigate('/login')}
              sx={{
                background: 'linear-gradient(135deg, #7C3AED 0%, #4B1FA6 100%)',
                borderRadius: '12px', textTransform: 'none', fontWeight: 600, px: 4,
                '&:hover': { background: 'linear-gradient(135deg, #8B5CF6 0%, #5B21B6 100%)' }
              }}
            >
              Ir para o Login
            </Button>
          </Box>
        ) : (
          <form onSubmit={handleSubmit}>
            <TextField
              fullWidth label="Nova Senha" type="password" value={formData.novaSenha}
              onChange={(e) => setFormData(prev => ({ ...prev, novaSenha: e.target.value }))}
              margin="normal" required
            />
            <TextField
              fullWidth label="Confirmar Nova Senha" type="password" value={formData.confirmSenha}
              onChange={(e) => setFormData(prev => ({ ...prev, confirmSenha: e.target.value }))}
              margin="normal" required
            />
            <Button
              type="submit" fullWidth variant="contained" disabled={loading}
              sx={{
                mt: 3, mb: 2, background: 'linear-gradient(135deg, #7C3AED 0%, #4B1FA6 100%)',
                color: '#fff', padding: '12px', borderRadius: '12px', textTransform: 'none',
                fontSize: '1rem', fontWeight: 600,
                '&:hover': { background: 'linear-gradient(135deg, #8B5CF6 0%, #5B21B6 100%)' }
              }}
              startIcon={loading ? <CircularProgress size={20} sx={{ color: '#fff' }} /> : null}
            >
              {loading ? 'Redefinindo...' : 'Redefinir Senha'}
            </Button>
          </form>
        )}
      </StyledPaper>
    </PageContainer>
  );
}
